import { num } from '@/lib/format'

import { CASE_PAGE_SIZE, pageCountFor } from './paging'

/** "Showing 26–50 of 340 · page 2 of 14", or as much of it as is known. */
export function PageSummary({
  page, rowsOnPage, total, pageSize = CASE_PAGE_SIZE, emptyLabel = 'No matching cases',
}: { page: number; rowsOnPage: number; total: number | null; pageSize?: number; emptyLabel?: string }) {
  const pageCount = pageCountFor(total, pageSize)
  if (total === null || pageCount === null) {
    return <>Showing {num(rowsOnPage)} · page {page + 1}</>
  }
  if (total === 0) return <>{emptyLabel}</>
  return (
    <>
      Showing {num(page * pageSize + 1)}–{num(page * pageSize + rowsOnPage)} of {num(total)}
      {' '}· page {page + 1} of {num(pageCount)}
    </>
  )
}

/** Prev / Next. Without a total, a short page is taken to be the last one. */
export function PagerButtons({
  page, setPage, rowsOnPage, total, pageSize = CASE_PAGE_SIZE,
}: {
  page: number
  setPage: (update: (p: number) => number) => void
  rowsOnPage: number
  total: number | null
  pageSize?: number
}) {
  const atEnd = total !== null ? (page + 1) * pageSize >= total : rowsOnPage < pageSize
  return (
    <>
      <button
        type="button"
        disabled={page === 0}
        onClick={() => setPage((p) => Math.max(0, p - 1))}
        className="text-2xs font-semibold uppercase tracking-wider text-navy-700 disabled:text-slate-300"
      >
        ← Prev
      </button>
      <button
        type="button"
        disabled={atEnd}
        onClick={() => setPage((p) => p + 1)}
        className="text-2xs font-semibold uppercase tracking-wider text-navy-700 disabled:text-slate-300"
      >
        Next →
      </button>
    </>
  )
}
